export const comments = [
  {
    id: "c-1",
    topicId: "variety-editing-debate",
    user: "柠檬气泡水",
    time: "1 小时前",
    content:
      "预告里那个片段我反复看了三遍，正片确实没出现。希望加更能补上，不然真的会一直惦记。",
    likes: 128,
  },
  {
    id: "c-2",
    topicId: "variety-editing-debate",
    user: "半糖不加冰",
    time: "52 分钟前",
    content:
      "我是做后期的，说句实话，留悬念是常规操作，但前提是别把主线剪断。这期的问题在于中间那段铺垫太长了。",
    likes: 96,
  },
  {
    id: "c-3",
    topicId: "variety-editing-debate",
    user: "追综艺的路人",
    time: "40 分钟前",
    content: "站中立。好看我就继续看，不好看就快进，没必要上升到态度问题。",
    likes: 61,
  },
  {
    id: "c-4",
    topicId: "variety-editing-debate",
    user: "夜猫子小林",
    time: "21 分钟前",
    content: "片尾加一句下期预告真的不难，成本几乎为零，但能少吵一半。这条建议值得节目组看看。",
    likes: 154,
  },
  {
    id: "c-5",
    topicId: "drama-ending-divide",
    user: "橘子汽水",
    time: "3 小时前",
    content:
      "我是冲着强情节来的，结果给我一个慢收尾，说不失望是假的。但平心而论，演员最后那段表演是真的好。",
    likes: 187,
  },
  {
    id: "c-6",
    topicId: "drama-ending-divide",
    user: "看剧笔记",
    time: "2 小时前",
    content: "那个长图整理得很用心，把回收和没回收的伏笔都列出来了。看完之后我对结局的接受度高了不少。",
    likes: 143,
  },
  {
    id: "c-7",
    topicId: "drama-ending-divide",
    user: "路人甲同学",
    time: "1 小时前",
    content: "建议分成两种推荐语这个想法很棒，比单纯争好坏实用多了。",
    likes: 88,
  },
  {
    id: "c-8",
    topicId: "concert-ticket-rush",
    user: "排队排到天亮",
    time: "5 小时前",
    content: "进度条到 90% 让我重新登录，那一刻真的想把手机扔了。流程问题比买不到更让人难受。",
    likes: 165,
  },
  {
    id: "c-9",
    topicId: "concert-ticket-rush",
    user: "冷静的瓜友",
    time: "4 小时前",
    content: "候补机制真的很重要，有候补大家至少愿意等，没有候补就只能去二手平台，然后价格就飞了。",
    likes: 132,
  },
  {
    id: "c-10",
    topicId: "concert-ticket-rush",
    user: "票根收藏家",
    time: "2 小时前",
    content: "开演前一周价格回落这条太真实了，我上次就是提前买亏了，血泪教训。",
    likes: 74,
  },
  {
    id: "c-11",
    topicId: "endorsement-logic",
    user: "市场部打工人",
    time: "6 小时前",
    content: "换代言人真不一定是策略摇摆，不同产品线用不同人很正常，大众线要声量，高端线要质感。",
    likes: 109,
  },
  {
    id: "c-12",
    topicId: "endorsement-logic",
    user: "理性吃瓜",
    time: "3 小时前",
    content: "把前提说清楚这一点太重要了。很多争论到最后发现大家说的根本不是一回事。",
    likes: 93,
  },
  {
    id: "c-13",
    topicId: "reality-show-lineup",
    user: "海报分析员",
    time: "1 天前",
    content: "站位确实值得看，但也别过度解读啦，设计稿很多时候只是好看优先。",
    likes: 77,
  },
  {
    id: "c-14",
    topicId: "reality-show-lineup",
    user: "等更新的人",
    time: "1 天前",
    content: "首期做轻量一点这个建议我举双手赞成，磨合期硬上强任务真的会崩。",
    likes: 91,
  },
  {
    id: "c-15",
    topicId: "short-drama-boom",
    user: "编剧朋友",
    time: "2 天前",
    content: "现在确实是好剧本比流量金贵，获客成本涨了，只有留得住人的内容才回本。这话说出来有点扎心。",
    likes: 118,
  },
  {
    id: "c-16",
    topicId: "short-drama-boom",
    user: "路过看看",
    time: "2 天前",
    content: "希望能少一点套路，多看两眼剧本。观众其实不傻，猜得出走向就不会付费了。",
    likes: 85,
  },
];